(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-shared/pix/assets/javascripts/pix.js') >= 0) return;  svs.modules.push('/components/marketplace-shared/pix/assets/javascripts/pix.js');

'use strict';

const Pix = _ref => {
  let branding = _ref.branding,
    children = _ref.children;
  return React.createElement("div", {
    className: "pix pix-".concat(branding)
  }, React.createElement("div", {
    className: "pix-title"
  }, React.createElement("span", null, "PIX!")), React.createElement("div", {
    className: "pix-sub-title"
  }, React.createElement("span", null, "F\xE4rdiga spel. Helt enkelt.")), React.createElement("div", {
    className: "pix-content"
  }, children));
};
setGlobal('svs.components.marketplaceShared.pix.Pix', Pix);

 })(window);